import * as KatalMetrics from "@amzn/katal-metrics";
import KatalMetricsDriverSushi from "@amzn/katal-metrics-driver-sushi";
import { createMetricsPublisher } from "@amzn/katal-metrics-mons";
import KatalMetricsDriverArrayCollector from "@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector";
import KatalMetricsDriverConsoleLogJson from "@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson";

const metricsConsoleErrorHandler = (err: Error) => console.error(err);

declare global {
  interface Window {
    metricsDriver?: KatalMetricsDriverArrayCollector;
  }
}

const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
  // Note that if we are in production or SERVER_MODE 'mons' we auto-configure before running this function.
  // So for Mons apps these configurations are just for unit tests and local server tests.
  if (process.env.NODE_ENV === "test") {
    const metricsDriver = new KatalMetricsDriverArrayCollector();
    //  Attach to global window object so tests can see it
    window.metricsDriver = metricsDriver;
    return metricsDriver;
  } else if (process.env.NODE_ENV !== "production") {
    return new KatalMetricsDriverConsoleLogJson();
  } else {
    return new KatalMetricsDriverSushi.Builder()
      .withDomainRealm("test", "USAmazon")
      .withErrorHandler(metricsConsoleErrorHandler)
      .build();
  }
};

const makePublisher = (): KatalMetrics.Publisher => {
  if (!SERVER_MODE || SERVER_MODE === "mons") {
    return createMetricsPublisher();
  }
  // Otherwise we are running a test server outside of Mons so cannot use KatalMetricsMons to auto-configure.
  return makeProdPublisher();
};

// Creating a separate metrics publisher with 'prod' domain to publish pageView metrics.
const makeProdPublisher = (): KatalMetrics.Publisher => {
  const metricsDriver = makeMetricsDriver();
  // Disable ESLint here because KatalMetrics.Context.Builder does not properly export type
  /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access */
  const initialMetricsContext: KatalMetrics.Context = new KatalMetrics.Context.Builder()
    .withSite("SellerCentral")
    .withServiceName("KatalMonsReactApplication")
    .build();
  /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access */
  return new KatalMetrics.Publisher(
    metricsDriver,
    metricsConsoleErrorHandler,
    initialMetricsContext
  );
};

const initialMetricsPublisher = makePublisher();

export default initialMetricsPublisher;
